import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import AddSellerGraduateForm from './AddSellerGraduateForm';

const ScheduleSeller = (props) => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<AddSellerGraduateForm 
			SchoolStorageID={schoolID}
			{...props}
		/>

	);
};

export default ScheduleSeller;
